import logo from "@/assets/images/Prud_Logo.png";
import AgentStepper from "../../Stepper/AgentStepper";

const AgentSideBar = () => {
  return (
    <div className="flex ">
      <aside className="flex bg-lightGray/30  ">
        <div
          className={`relative flex flex-col gap-4 transition-all duration-200 ease-in-out bg-lightGray/30 p-5 pt-5 h-screen w-60`}
        >
          <div className="flex items-center justify-center w-full h-16 border-b-gray-100">
            <img src={logo} className={` w-30 mix-blend-darken`} alt="logo" />
          </div>

          <AgentStepper />
        </div>
      </aside>
    </div>
  );
};

export default AgentSideBar;
